import { Component, Input, OnChanges } from '@angular/core';

import { ChartTooltipModel }         from '../typings/intelligence.chart-tooltip';
import { DonutSegmentModel }         from '../typings/intelligence.donut-segment';
import { IntelligenceFormatService } from '../intelligence.format.service';

interface RenderedSegment {
  color     : string;
  dashArray : string;
  dashOffset: number;
  label     : string;
  percent   : number;
  value     : number;
}

@Component({
  selector   : 'wor-intelligence-donut-chart',
  template: require('./intelligence.donut-chart.component.html')
})
export class DonutChartComponent implements OnChanges {
  @Input() centerLabel = '';
  @Input() format = 'money';
  @Input() segments : Array<DonutSegmentModel> = [];

  circumference = 2 * Math.PI * 70;
  hoverIndex = -1;
  rendered : Array<RenderedSegment> = [];
  tooltip : ChartTooltipModel = { rows: [], title: '', visible: false, x: 0, y: 0 };
  total = 0;

  constructor (
    private intelligenceFormatService: IntelligenceFormatService
  ) {}

  ngOnChanges () : void {
    this.render();
  }

  formatValue ( value : number ) : string {
    return this.format === 'count'
      ? this.intelligenceFormatService.count(value)
      : this.intelligenceFormatService.money(value);
  }

  hideTooltip () : void {
    this.hoverIndex = -1;
    this.tooltip = { ...this.tooltip, visible: false };
  }

  onMove ( event : MouseEvent, segment : RenderedSegment, index : number ) : void {
    const wrapper = ( event.currentTarget as Element ).closest('.intelligence-chart-wrapper') as HTMLElement;
    const bounds = wrapper.getBoundingClientRect();

    this.hoverIndex = index;

    this.tooltip = {
      rows: [{
        color: segment.color,
        label: segment.label,
        prior: `${ segment.percent.toFixed(1) }%`,
        value: this.formatValue(segment.value)
      }],
      title  : segment.label,
      visible: true,
      x      : Math.min(event.clientX - bounds.left + 14, bounds.width - 170),
      y      : Math.max(event.clientY - bounds.top - 10, 4)
    };
  }

  private render () : void {
    this.hideTooltip();
    this.rendered = [];
    this.total = this.segments.reduce(( sum, segment ) => sum + Math.max(segment.value, 0), 0);

    if ( this.total <= 0 ) {
      return;
    }

    let offset = 0;

    this.rendered = this.segments
      .filter(segment => segment.value > 0)
      .map(segment => {
        const percent = ( segment.value / this.total ) * 100;
        const length = ( segment.value / this.total ) * this.circumference;
        const item = {
          color     : segment.color,
          dashArray : `${ Math.max(length - 2, 0) } ${ this.circumference - Math.max(length - 2, 0) }`,
          dashOffset: -offset,
          label     : segment.label,
          percent,
          value     : segment.value
        };

        offset += length;

        return item;
      });
  }
}
